import styled, { css } from 'styled-components'
import { Link } from 'react-router-dom';


export const SC_FormGroup = styled.div.attrs(props => ({
	className: "form-group",
}))`

`

export const SC_Label = styled.label.attrs(props => ({
	className: "label",
}))`

`

export const SC_FormControlInput = styled.input.attrs(props => ({
	className: "form-control",
}))`

`

export const SC_FormControlSelect = styled.select.attrs(props => ({
	className: "form-control",
}))`
	text-indent: ${props => props.theme.inputBtnPaddingY};
`

export const SC_FormCheck = styled.div.attrs(props => ({
	className: "form-check"
}))`

`

export const SC_FormControlFile = styled.div.attrs(props => ({
	className: "custom-file"
}))`

`

export const SC_FormLink = styled(Link).attrs(props => ({
	className: "text-muted",
}))`

`

function buttonStyles(tag){
	const styles = styled(tag).attrs(props => ({
		className: "btn",
		role: "button"
	}))`
		width: ${props => props.block ? '100%' : (props.width ? props.width : 'auto')};
		display: inline-flex;
		justify-content: center;
	
		&+.btn {
			margin-left: ${props => props.block ? '0' : parseFloat(props.theme.inputBtnFocusWidth)*4}rem;
			margin-top: ${props => props.block ? parseFloat(props.theme.inputBtnFocusWidth)*4 : '0'}rem;
		}
	
		&>.icon-container {
			height: 23px;
			display: flex;
			align-items: center;
			margin-left: -${props => props.theme.inputBtnPaddingX};
			${props => props.icononly ? `
			margin-right: -${props.theme.inputBtnPaddingX};
			` : null}
		}	
	
		&.btn-link {
			font-weight: ${props => props.theme.fontWeightBold};
			padding-right: 0;
			padding-left: 0;
			color: ${props => props.theme.btnLinkColor};
			${props => props.icon ? `
			justify-content: space-between;
			text-align: left;
	
			&>.icon-container {
				order: 2;
			}
			` : null }
		}
	`;
	return styles; 
}

export const SC_ButtonInternal = buttonStyles(Link);
export const SC_ButtonExternal = buttonStyles('a');
export const SC_ButtonFunctional = buttonStyles('button');
export const SC_ButtonSubmit = buttonStyles('input');